import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export const CenteredTypographyBox = ({
  value,
  unit,
}: {
  value: string | number | null;
  unit: string | null;
}) => {
  const valueExists = (
    <Typography variant="h4">
      {Number(value).toFixed(2)} {unit}
    </Typography>
  );

  const valueNonExists = (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Typography variant="body1" sx={{ textAlign: 'center' }}>
        --
      </Typography>
      <Typography variant="body2">Non Applicable</Typography>
    </Box>
  );

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      {value !== null && value !== undefined ? valueExists : valueNonExists}
    </Box>
  );
};
